
$(document).ready(function(){
  let inputs = $("input[name='selling_plan']");
if (inputs.length > 1) {
  inputs.slice(1).remove();
}

  /*                                Subscription 21-Jan-2024                                                     */
$(document).on('click','.quick-add-button-variants',function(){
 var product_id =  $(this).closest(".grid-view-item").attr("data-product-value");
  setTimeout(function() {       
   window.ReChargeWidget.createWidget({ productId: product_id, injectionParent: '.rc-widget-injection-parent' });
   window.ReChargeWidget.getWidgets();
      
  }, 4000);
});
$(document).on("change",".rc-selling-plans-dropdown__select",function(){
  const sellingId = $(this).val();
  $(".cstmSellingPlanId").val(sellingId);
});
$(document).on("click", ".subscription-radio", function(){
    const sellingId = $(".cstmsellingattr").attr("cstmsellingattr");
    $(".cstmSellingPlanId").val(sellingId);
});
$(document).on("click", ".onetime-radio", function(){
    $(".cstmSellingPlanId").val("");
});

var currentUrl = window.location.href;
var sellingPlanValue = currentUrl.match(/selling_plan=(\d+)/);
if (sellingPlanValue) {
$(".cstmSellingPlanId").val(sellingPlanValue[1]);
}

var openCart = $('.openCart').attr('opencart');
if(localStorage.getItem('clicked') === 'true') {
  if(openCart == 'opencart'){
   setTimeout(function() {
     var cartItem = $('.cart-item-count-bubble');
    if (cartItem.length) {
      cartItem.first().trigger('click');  
    }
   }, 500)
  }
}

$('#subscription--add-to-cart').click(function() {
   localStorage.setItem('clicked', 'true');
});

$('body').click(function(e) {
    if (!$(e.target).is('#subscription--add-to-cart')) {
        localStorage.removeItem('clicked');
    }
});
/*                                 Subscription 21-Jan-2024                                                      */

/*                                 Grind-Size-Guide Pop-Box Js 04-June-2024                                                     */
  if(window.matchMedia("(min-width: 767px)").matches){
      var maxHeight = 0;
      $('.collage-builder__text-container--inner').each(function() {
          var boxHeight = $(this).outerHeight();
          if (boxHeight > maxHeight) {
              maxHeight = boxHeight;
          }
      });
      $('.collage-builder__text-container--inner').each(function() {
          $(this).height(maxHeight);
      });
  }
  
  $(document).on("click",".grindShowBtn",function(e){
    e.preventDefault();
     $("body").addClass("grindSizeBox");
     $(".grind-main-top-container").css("display","flex");
  });
  
  $(document).on("click",".closeBtnClass",function(e){
    e.preventDefault(); 
    $(".grind-main-top-container").hide();
    $("body").removeClass("grindSizeBox");
  });
});
/*                                 Grind-Size-Guide Pop-Box Js 04-June-2024                                                     */

if ($(window).width() < 768) {
$('body').on('click','footer.footer-main .grid__item.links-footer',function () {
  $(this).toggleClass('footer-active');   
})
}
 $(document).on("change",".pdp-option-gift input",function(){
  var gift_opt_val = $(this).val();
  if(gift_opt_val == 'Yes'){
  $(".ajax-cart--gift-note").show();
    var cart_bottom_height = $(".ajaxcart__footer-wrapper").height();
  }else{
  $(".ajax-cart--gift-note").hide();
  $("textarea#CartGiftNote").val('');
    var cart_bottom_height = $(".ajaxcart__footer-wrapper").height();
  }
  });

function slickCarousel() {
  $("#jtpl_cart_collection_wrapper").slick({
    slidesToShow: 1,
    infinite:true,
    autoplay: true,
    autoplaySpeed: 2000,
     dots: true,
    rows: 0,
    arrows: false
  });
}
function priceContainer($clickedEl) {
      console.log("▶ priceContainer start, clicked element:", $clickedEl);

    // jis product pr click hua uska row
    let productRow = $clickedEl.closest(".ajaxcart__product");

    console.log("🟢 Product row:", productRow);

    // saare products
    let allRows = $(".ajaxcart__product");

    // yeh wala index = clicked row ka index
    let index = allRows.index(productRow[0]);

    console.log("📌 Calculated index:", index);

    fetch('/cart.js')
        .then(res => res.json())
        .then(data => {
    console.log("🛒 Cart Data:", data);
            let item = data.items[index];
            if (!item) return console.warn("Item not found at index", index);

            let comparePrice = item.selling_plan_allocation?.compare_at_price;
            let OriginalcomparePrice = item.selling_plan_allocation?.per_delivery_price;
            if (!comparePrice) return console.warn("No compare price");

            let price = comparePrice / 100;
            let Originalprice = OriginalcomparePrice / 100;
            let priceElement = productRow.find(".ajaxcart__product-compare")[0];

            if (!priceElement) return console.warn("Price element missing");
            if(price !== Originalprice ){
            priceElement.innerHTML = `
                <span style="color:black; text-decoration:line-through;">
                    $${price.toFixed(2)}
                </span>
            `;
           }
            console.log("✔ Compare price updated for clicked item");
        });
}
function updateComparePriceForRemainingItems(removedIndex) {
    console.log("▶ updateComparePriceForRemainingItems start, excluding index:", removedIndex);

    // Fetch the updated cart data
    fetch('/cart.js')
        .then(res => res.json())
        .then(data => {
            console.log("🛒 Updated Cart Data:", data);

            let allRows = $(".ajaxcart__product");
            // Loop through all items in the cart
            data.items.forEach((item, index) => {
                if (index === removedIndex) return; // Skip the removed item

                // Get the product row based on the index
                let productRow = allRows.eq(index);
                let comparePrice = item.selling_plan_allocation?.compare_at_price;
                let OriginalcomparePrice = item.selling_plan_allocation?.per_delivery_price;

                if (!comparePrice) return console.warn("No compare price for item at index", index);

                // Convert the compare price to a readable format
                let price = comparePrice / 100;
                let Originalprice = OriginalcomparePrice / 100;
                // Find the price element in the row
                let priceElement = productRow.find(".ajaxcart__product-compare")[0];

                if (!priceElement) return console.warn("Price element missing for item at index", index);
                if(price !== Originalprice ){
                                // Update the compare price in the DOM
                                priceElement.innerHTML = `
                                    <span style="color:black; text-decoration:line-through;">
                                        $${price.toFixed(2)}
                                    </span>
                                `;
                }
                console.log(`✔ Compare price updated for item at index ${index}`);
            });
        })
        .catch(err => console.error("Error fetching cart data:", err));
}


function getCart(){
 
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cartData) {
      console.log(cartData);
      $('.ajaxcart__subtotal .money').html('$'+cartData.total_price/100);
      $('.cart_pro_wrapp').html('');
        for (var i = 0; i < cartData.items.length; i++) {
          var item = cartData.items[i];
          $('.cart_pro_wrapp').append(`<div class="ajaxcart__product"><div data-line="1" class="ajaxcart__row"><div class="grid display-table"><div class="grid__item small--one-whole medium--one-quarter large--one-quarter medium--display-table-cell"><a href="${item.url}" class="ajaxcart__product-image"><img src="${item.image}" alt="KENYA LIMITED EDITION" srcset="//www.domacoffee.com/cdn/shop/files/Kenya-Nyeri-Peaberry-Badge-12oz.jpg?v=1696019852 0w" loading="lazy"></a></div><div class="grid__item small--one-whole medium--two-quarters large--two-quarters medium--display-table-cell"><p><a href="/products/kenya-limited-edition-1?variant=40157316186174" class="ajaxcart__product-name">${item.title}</a></p><div class="custom_quantity"><div class="grid--full text-left ajaxcart__quantity-wrapper"><div class="grid__item"><div class="ajaxcart__qty"><button type="button" class="ajaxcart__qty-adjust ajaxcart__qty--minus icon-fallback-text" data-id="${item.id}"><svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" aria-hidden="true" class="flex-full"><path d="M5 10H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg><span class="fallback-text">−</span></button><input value="${item.quantity}" type="text" name="updates[]" min="0" aria-label="quantity" pattern="[0-9]*" class="ajaxcart__qty-num get-qty-${item.id}"><button type="button" class="ajaxcart__qty-adjust ajaxcart__qty--plus icon-fallback-text" data-id="${item.id}"><svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20" aria-hidden="true" class="flex-full"><path d="M5 10H10M10 10H15M10 10V5M10 10V15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg><span class="fallback-text">+</span></button></div></div></div><div class="text-left custom_all-price-wrapp"><s></s><span class="price-no--discount hide">${item.discounted_price}</span><span class="ajaxcart-item__price custom_original_price" style=""><span class="money">$${item.final_line_price/100}</span></span></div><button type="button" data-id="${item.id}" class="ajaxcart__qty-remove" >X</button></div><ul aria-label="Discount" class="ajaxcart-item__discounts"></ul></div></div></div></div>`);
        }
    },
    error: function(xhr, status, error) {
        console.error(error);
    }
  });
}

function cart_drawer_slider() {
 
  slickCarousel();
  
 $('body').on('click','.jtpl_AddToCart',function () {

    $('.errorMessage').hide();
    console.log('clicked==');
    var productId = $(this).siblings('.jtpl_drawer_bottom_product_id').val();
    console.log('productId=='+productId);
    const ctm_quantity = 1;
   var items = [{ quantity: ctm_quantity, id: productId }];
   $.ajax({
       type: "POST",
       url: '/cart/add.js',
       data: { items: items },
       dataType: 'json',
       success: function(data) {
         console.log(data);
          getCart();
         
          $(".discounted_value").remove();
          $(".custom_original_price").hide();
          var free_ship_text = $("body").attr("free-shipping");
          setTimeout(function(){
            jQuery.getJSON('/cart.js', function(cart) {
            $(".CartCount__icon-text").html(cart.item_count);
            var cart_val_div = cart.total_price / 100;
            const newPercentValue = (cart_val_div / free_ship_text) * 100;
            let items = cart.items;
            for(var i=0; i < items.length; i++){
              if(typeof items[i].selling_plan_allocation !== 'undefined'){
                //  $('.progress-bar').css('width','100%');   
                //  $(".free_shipping_message").show();
                //  $(".simple_freeshipping_text p").hide();
                 var free_ship_text = $(".progress_main_bar .progress-bar").attr("free-shipping");

    /* ---------------------------------------------------
     *  1️⃣ Update shipping progress bar & message
     * --------------------------------------------------- */
    setTimeout(function () {
        // alert(2)
        jQuery.getJSON('/cart.js', function (cart) {

            $(".CartCount__icon-text").html(cart.item_count);

            var cart_val_div = cart.total_price / 100;
            const newPercentValue = (cart_val_div / free_ship_text) * 100;

            let items = cart.items;

            let hasSellingPlan = items.some(item => item.selling_plan_allocation);

            // FREE SHIPPING if cart value >= threshold
            if (cart_val_div >= free_ship_text) {
                $('.progress-bar').css('width', '100%');
                $(".free_shipping_message").show();
                $(".simple_freeshipping_text p").hide();
            } else {
                $('.progress-bar').css('width', newPercentValue + '%');

                const remain = (free_ship_text - cart_val_div).toFixed(2);
                $(".simple_freeshipping_text p b").html("$" + remain);

                if (remain > 0) {
                    $(".simple_freeshipping_text p").show();
                    $(".free_shipping_message").hide();
                } else {
                    $(".free_shipping_message").show();
                    $(".simple_freeshipping_text p").hide();
                }
            }

            // When cart is empty
            if (cart.item_count < 1) {
                $('.progress-bar').css('width', '0%');
                $(".simple_freeshipping_text p b").html("$" + free_ship_text);
                $(".simple_freeshipping_text p").show();
                $(".free_shipping_message").hide();
            }

        });
    }, 500);
              }else{
              
                 $('.progress-bar').css('width',newPercentValue+'%');   
                 const newPercentValue2 = (free_ship_text - cart_val_div);
                 const final_val = newPercentValue2.toFixed(2)
                 $(".simple_freeshipping_text p b").html("$"+final_val);
                 if(newPercentValue2 > 0){
                  $(".simple_freeshipping_text p").show();
                  $(".free_shipping_message").hide();
                 }else{
                  $(".free_shipping_message").show();
                  $(".simple_freeshipping_text p").hide();
                 }
             }
          }
          if(cart.item_count < 1)   {
            $('.progress-bar').css('width',newPercentValue+'%');   
            const newPercentValue2 = (free_ship_text - cart_val_div);
            const final_val = newPercentValue2.toFixed(2)
            $(".simple_freeshipping_text p b").html("$"+final_val);
            if(newPercentValue2 > 0){
              $(".simple_freeshipping_text p").show();
              $(".free_shipping_message").hide();
            }else{
              $(".free_shipping_message").show();
              $(".simple_freeshipping_text p").hide();
            }
          }
        });     
        var cart_bottom_height = $(".ajaxcart__footer-wrapper").height();
        $(".ajaxcart__product").each(function() {
          var discounted_price = $(this).find(".discounted_price_main").text();
          if(discounted_price == ''){
              $(this).find(".custom_original_price").show();
          }else{
              $(this).find(".custom_original_price").hide();
          }
        });
       },500);
      setTimeout(function(){
        var gift_opt_val = $(".pdp-option-gift input:checked").val();
        if(gift_opt_val == 'Yes'){
          $(".ajax-cart--gift-note").show();
        }else{
          $("textarea#CartGiftNote").val('');
          $(".ajax-cart--gift-note").hide();   
        }
        jQuery.getJSON('/cart.js', function(cart) {
          let items = cart.items;
          for(var i=0; i < items.length; i++){
            if(typeof items[i].selling_plan_allocation !== 'undefined'){
              $(".cart_drawer_main form.cart.ajaxcart").append('<input class="discounted_value" type="hidden" name="discount" value="FREESUBSHIP" >')
            }
          }
        });
      },2000);        
      },
       error: function(error) {
          console.log(error.responseJSON.description);
         $('.errorMessage').html(error.responseJSON.description);
         $('.errorMessage').show();
      }
    });
     
  });

}

  $(document).on("click","a.site-header__cart-toggle, .js-drawer-open-right-link", function(){
   
    setTimeout(function(){
    jQuery.getJSON('/cart.js', function(cart) {

var getCartcount = cart.item_count;
    if(getCartcount == 0){

 $('.cart_pro_wrapp').html('');
        $('span.cart-item-count-bubble.cart-item-count-header.cart-item-count-header--quantity.hide').text(0);
      var getCathtml =  $('.custom_cart_btns').html();
$('div#CartContainer').html(getCathtml);
      $('.empty_cart_btns.not_empty_cart').show();
    }
      })
     }, 300);
       setTimeout(function(){
    cart_drawer_slider();
}, 1000);

setTimeout(function(){
    $('.slick-activator').show();
}, 997);

     setTimeout(function(){
      var cart_bottom_height = $(".ajaxcart__footer-wrapper").height();
     },1600);

    $(".discounted_value").remove();
    $(".custom_original_price").hide();
    var free_ship_text = $("body").attr("free-shipping");
    setTimeout(function(){
        jQuery.getJSON('/cart.js', function(cart) {
  $(".CartCount__icon-text").html(cart.item_count);
          var cart_val_div = cart.total_price / 100;
const newPercentValue = (cart_val_div / free_ship_text) * 100;
       let items = cart.items;
    for(var i=0; i < items.length; i++){
if(typeof items[i].selling_plan_allocation !== 'undefined'){
//    $('.progress-bar').css('width','100%');   
//    $(".free_shipping_message").show();
//             $(".simple_freeshipping_text p").hide();
 var free_ship_text = $(".progress_main_bar .progress-bar").attr("free-shipping");

    /* ---------------------------------------------------
     *  1️⃣ Update shipping progress bar & message
     * --------------------------------------------------- */
    setTimeout(function () {
        // alert(2)
        jQuery.getJSON('/cart.js', function (cart) {

            $(".CartCount__icon-text").html(cart.item_count);

            var cart_val_div = cart.total_price / 100;
            const newPercentValue = (cart_val_div / free_ship_text) * 100;

            let items = cart.items;

            let hasSellingPlan = items.some(item => item.selling_plan_allocation);

            // FREE SHIPPING if cart value >= threshold
            if (cart_val_div >= free_ship_text) {
                $('.progress-bar').css('width', '100%');
                $(".free_shipping_message").show();
                $(".simple_freeshipping_text p").hide();
            } else {
                $('.progress-bar').css('width', newPercentValue + '%');

                const remain = (free_ship_text - cart_val_div).toFixed(2);
                $(".simple_freeshipping_text p b").html("$" + remain);

                if (remain > 0) {
                    $(".simple_freeshipping_text p").show();
                    $(".free_shipping_message").hide();
                } else {
                    $(".free_shipping_message").show();
                    $(".simple_freeshipping_text p").hide();
                }
            }

            // When cart is empty
            if (cart.item_count < 1) {
                $('.progress-bar').css('width', '0%');
                $(".simple_freeshipping_text p b").html("$" + free_ship_text);
                $(".simple_freeshipping_text p").show();
                $(".free_shipping_message").hide();
            }

        });
    }, 500);
}else{
   $('.progress-bar').css('width',newPercentValue+'%');   
   const newPercentValue2 = (free_ship_text - cart_val_div);
          const final_val = newPercentValue2.toFixed(2)
   $(".simple_freeshipping_text p b").html("$"+final_val);
                      if(newPercentValue2 > 0){
            $(".simple_freeshipping_text p").show();
            $(".free_shipping_message").hide();
          }else{
            $(".free_shipping_message").show();
            $(".simple_freeshipping_text p").hide();
          }
}
}
               if(cart.item_count < 1)   {
        $('.progress-bar').css('width',newPercentValue+'%');   
   const newPercentValue2 = (free_ship_text - cart_val_div);
          const final_val = newPercentValue2.toFixed(2)
   $(".simple_freeshipping_text p b").html("$"+final_val);
                      if(newPercentValue2 > 0){
            $(".simple_freeshipping_text p").show();
            $(".free_shipping_message").hide();
          }else{
            $(".free_shipping_message").show();
            $(".simple_freeshipping_text p").hide();
          }
      }

        });     
           var cart_bottom_height = $(".ajaxcart__footer-wrapper").height();
$(".ajaxcart__product").each(function() {
    var discounted_price = $(this).find(".discounted_price_main").text();
    if(discounted_price == ''){
        $(this).find(".custom_original_price").show();
    }else{
        $(this).find(".custom_original_price").hide();
    }
});
    },500);
setTimeout(function(){
          var gift_opt_val = $(".pdp-option-gift input:checked").val();
  if(gift_opt_val == 'Yes'){
  $(".ajax-cart--gift-note").show();
  }else{
    $("textarea#CartGiftNote").val('');
  $(".ajax-cart--gift-note").hide();
  
  }
          jQuery.getJSON('/cart.js', function(cart) {
    let items = cart.items;
    for(var i=0; i < items.length; i++){
if(typeof items[i].selling_plan_allocation !== 'undefined'){
$(".cart_drawer_main form.cart.ajaxcart").append('<input class="discounted_value" type="hidden" name="discount" value="FREESUBSHIP" >')
}
}
});
 },2000);
});

$('body').on('click', '#AddToCart', function(){
  setTimeout(function(){   
  cart_drawer_slider();
   },2000);
    setTimeout(function(){
    
     slickCarousel();
   }, 2000)
  
});

$(document).on("click","button#AddToCart, .quick-add-button", function(){
//  let $clickedEl = $(this);
//  setTimeout(function() {
//         priceContainer($clickedEl);
//     }, 4000);
  setTimeout(function(){
slickCarousel();
    cart_drawer_slider();
  }, 2000);
  setTimeout(function(){
    $('.slick-activator').show();
}, 1997); 

  $(".discounted_value").remove();
  $(".custom_original_price").hide();
    var free_ship_text = $("body").attr("free-shipping");
    setTimeout(function(){
        
        jQuery.getJSON('/cart.js', function(cart) {
            //   alert(1)
  $(".CartCount__icon-text").html(cart.item_count);
          var cart_val_div = cart.total_price / 100;
const newPercentValue = (cart_val_div / free_ship_text) * 100;
       let items = cart.items;
    for(var i=0; i < items.length; i++){
if(typeof items[i].selling_plan_allocation !== 'undefined'){
  //  $('.progress-bar').css('width','100%');   
  //  $(".free_shipping_message").show();
  //  $(".simple_freeshipping_text p").hide();
     $('.progress-bar').css('width', newPercentValue + '%');

      const newPercentValue2 = (free_ship_text - cart_val_div);
      const final_val = newPercentValue2.toFixed(2);

      $(".simple_freeshipping_text p b").html("$" + final_val);

      if (newPercentValue2 > 0) {
          $(".simple_freeshipping_text p").show();
          $(".free_shipping_message").hide();
      } else {
          $(".free_shipping_message").show();
          $(".simple_freeshipping_text p").hide();
      }
}else{
   $('.progress-bar').css('width',newPercentValue+'%');   
   const newPercentValue2 = (free_ship_text - cart_val_div);
          const final_val = newPercentValue2.toFixed(2)
   $(".simple_freeshipping_text p b").html("$"+final_val);
                      if(newPercentValue2 > 0){
            $(".simple_freeshipping_text p").show();
            $(".free_shipping_message").hide();
          }else{
            $(".free_shipping_message").show();
            $(".simple_freeshipping_text p").hide();
          }
}
}
         

        });    
           var cart_bottom_height = $(".ajaxcart__footer-wrapper").height();
      $(".ajaxcart__product").each(function() {
    var discounted_price = $(this).find(".discounted_price_main").text();
    if(discounted_price == ''){
        $(this).find(".custom_original_price").show();
    }else{
        $(this).find(".custom_original_price").hide();
    }
});
    },2000);
   setTimeout(function(){
                var gift_opt_val = $(".pdp-option-gift input:checked").val();
  if(gift_opt_val == 'Yes'){
  $(".ajax-cart--gift-note").show();
  }else{
    $("textarea#CartGiftNote").val('');
  $(".ajax-cart--gift-note").hide();
  
  }
             jQuery.getJSON('/cart.js', function(cart) {
    let items = cart.items;
    for(var i=0; i < items.length; i++){
if(typeof items[i].selling_plan_allocation !== 'undefined'){
$(".cart_drawer_main form.cart.ajaxcart").append('<input class="discounted_value" type="hidden" name="discount" value="FREESUBSHIP" >')
}
}
});
      },3000);
});
function updateCart(id, qty){
  var qty = 
  $.ajax({
   type: 'POST',
   url: '/cart/change.js',
   data: {
       id: id,
       quantity: qty
   },
   dataType: 'json',
   success: function(cartData) {
       getCart()
   },
   error: function(xhr, status, error) {
       console.error(error);
   }
});
}
// $(document).on("click",".ajaxcart__qty-remove", function(){
//    let $clickedEl = $(this);
//  setTimeout(function() {
//         updateComparePriceForRemainingItems($clickedEl);
//     }, 200);
//      $(".discounted_value").remove();
//     $(".custom_original_price").hide();
//     var free_ship_text = $(".progress_main_bar .progress-bar").attr("free-shipping");
//     setTimeout(function(){
//         jQuery.getJSON('/cart.js', function(cart) {
//   $(".CartCount__icon-text").html(cart.item_count);
//           var cart_val_div = cart.total_price / 100;
// const newPercentValue = (cart_val_div / free_ship_text) * 100;
//        let items = cart.items;
//     for(var i=0; i < items.length; i++){
// if(typeof items[i].selling_plan_allocation !== 'undefined'){
//    $('.progress-bar').css('width','100%');   
//    $(".free_shipping_message").show();
//             $(".simple_freeshipping_text p").hide();
// }else{
//    $('.progress-bar').css('width',newPercentValue+'%');   
//    const newPercentValue2 = (free_ship_text - cart_val_div);
//           const final_val = newPercentValue2.toFixed(2)
//    $(".simple_freeshipping_text p b").html("$"+final_val);
//                       if(newPercentValue2 > 0){
//             $(".simple_freeshipping_text p").show();
//             $(".free_shipping_message").hide();
//           }else{
//             $(".free_shipping_message").show();
//             $(".simple_freeshipping_text p").hide();
//           }
// }
// }
//                if(cart.item_count < 1)   {
//         $('.progress-bar').css('width',newPercentValue+'%');   
//    const newPercentValue2 = (free_ship_text - cart_val_div);
//           const final_val = newPercentValue2.toFixed(2)
//    $(".simple_freeshipping_text p b").html("$"+final_val);
//                       if(newPercentValue2 > 0){
//             $(".simple_freeshipping_text p").show();
//             $(".free_shipping_message").hide();
//           }else{
//             $(".free_shipping_message").show();
//             $(".simple_freeshipping_text p").hide();
//           }
//       }

//         });      
//     },500);
//     setTimeout(function(){
//             $(".ajaxcart__product").each(function() {
//     var discounted_price = $(this).find(".discounted_price_main").text();
//     if(discounted_price == ''){
//         $(this).find(".custom_original_price").show();
//     }else{
//         $(this).find(".custom_original_price").hide();
//     }
// });
//                    jQuery.getJSON('/cart.js', function(cart) {
//     let items = cart.items;
//     for(var i=0; i < items.length; i++){
// if(typeof items[i].selling_plan_allocation !== 'undefined'){
// $(".cart_drawer_main form.cart.ajaxcart").append('<input class="discounted_value" type="hidden" name="discount" value="FREESUBSHIP" >')
// }
// }
// });
//  },2000);
// });

$(document).on("click", ".ajaxcart__qty-remove", function () {

    let $clickedEl = $(this);

    // Update remaining item prices
    setTimeout(function () {
        updateComparePriceForRemainingItems($clickedEl);
    }, 200);

    $(".discounted_value").remove();
    $(".custom_original_price").hide();

    var free_ship_text = $(".progress_main_bar .progress-bar").attr("free-shipping");

    /* ---------------------------------------------------
     *  1️⃣ Update shipping progress bar & message
     * --------------------------------------------------- */
    setTimeout(function () {
        // alert(2)
        jQuery.getJSON('/cart.js', function (cart) {

            $(".CartCount__icon-text").html(cart.item_count);

            var cart_val_div = cart.total_price / 100;
            const newPercentValue = (cart_val_div / free_ship_text) * 100;

            let items = cart.items;

            let hasSellingPlan = items.some(item => item.selling_plan_allocation);

            // FREE SHIPPING if cart value >= threshold
            if (cart_val_div >= free_ship_text) {
                $('.progress-bar').css('width', '100%');
                $(".free_shipping_message").show();
                $(".simple_freeshipping_text p").hide();
            } else {
                $('.progress-bar').css('width', newPercentValue + '%');

                const remain = (free_ship_text - cart_val_div).toFixed(2);
                $(".simple_freeshipping_text p b").html("$" + remain);

                if (remain > 0) {
                    $(".simple_freeshipping_text p").show();
                    $(".free_shipping_message").hide();
                } else {
                    $(".free_shipping_message").show();
                    $(".simple_freeshipping_text p").hide();
                }
            }

            // When cart is empty
            if (cart.item_count < 1) {
                $('.progress-bar').css('width', '0%');
                $(".simple_freeshipping_text p b").html("$" + free_ship_text);
                $(".simple_freeshipping_text p").show();
                $(".free_shipping_message").hide();
            }

        });
    }, 500);

    /* ---------------------------------------------------
     *  2️⃣ Show/hide original price & add discount input for selling plan
     * --------------------------------------------------- */
    setTimeout(function () {

        // Show original price if no discounted price
        $(".ajaxcart__product").each(function () {
            var discounted_price = $(this).find(".discounted_price_main").text();
            if (discounted_price == '') {
                $(this).find(".custom_original_price").show();
            } else {
                $(this).find(".custom_original_price").hide();
            }
        });

        // Add discount input if selling plan exists
        jQuery.getJSON('/cart.js', function (cart) {
            let items = cart.items;
            let hasSellingPlan = items.some(item => item.selling_plan_allocation);

            if (hasSellingPlan) {
                // Append only if not already present
                if ($(".cart_drawer_main form.cart.ajaxcart .discounted_value").length === 0) {
                    $(".cart_drawer_main form.cart.ajaxcart")
                        .append('<input class="discounted_value" type="hidden" name="discount" value="FREESUBSHIP">');
                }
            }
        });

    }, 1200);

});

$(document).on('click', '.ajaxcart__qty-remove', function(e){
     let $clickedEl = $(this);
 setTimeout(function() {
        updateComparePriceForRemainingItems($clickedEl);
    }, 200);
e.preventDefault();

  var id = $(this).attr('data-id');
 
  removeCartItem(id)
   setTimeout(function(){
removeCartItem1(id)
   },500);
});
// $('body').on('click', '.ajaxcart__qty--plus', function(){
// let $clickedEl = $(this);
//  setTimeout(function() {
//         priceContainer($clickedEl);
//     }, 1000);
//   var id = $(this).attr('data-id');
//   var qty = parseInt($('.get-qty-'+id).val());
//   qty += 1;
//   updateCart(id,qty)
//      $(".discounted_value").remove();
//   $(".custom_original_price").hide();
//     var free_ship_text = $(".progress_main_bar .progress-bar").attr("free-shipping");
//     setTimeout(function(){
//         jQuery.getJSON('/cart.js', function(cart) {
//   $(".CartCount__icon-text").html(cart.item_count);
//           var cart_val_div = cart.total_price / 100;
// const newPercentValue = (cart_val_div / free_ship_text) * 100;
//        let items = cart.items;
//     for(var i=0; i < items.length; i++){
// if(typeof items[i].selling_plan_allocation !== 'undefined'){
//   console.log("cart_val_div"+cart_val_div);
//   console.log("newPercentValue"+newPercentValue)
 
  
// }else{
//    $('.progress-bar').css('width',newPercentValue+'%');   
//    const newPercentValue2 = (free_ship_text - cart_val_div);
//           const final_val = newPercentValue2.toFixed(2)
//    $(".simple_freeshipping_text p b").html("$"+final_val);
//                       if(newPercentValue2 > 0){
//             $(".simple_freeshipping_text p").show();
//             $(".free_shipping_message").hide();
//           }else{
//             $(".free_shipping_message").show();
//             $(".simple_freeshipping_text p").hide();
//           }
// }
// }
//                if(cart.item_count < 1)   {
//         $('.progress-bar').css('width',newPercentValue+'%');   
//    const newPercentValue2 = (free_ship_text - cart_val_div);
//           const final_val = newPercentValue2.toFixed(2)
//    $(".simple_freeshipping_text p b").html("$"+final_val);
//                       if(newPercentValue2 > 0){
//             $(".simple_freeshipping_text p").show();
//             $(".free_shipping_message").hide();
//           }else{
//             $(".free_shipping_message").show();
//             $(".simple_freeshipping_text p").hide();
//           }
//       }

//         });      
//     },500);
  

//       setTimeout(function(){
//             $(".ajaxcart__product").each(function() {
//     var discounted_price = $(this).find(".discounted_price_main").text();
//     if(discounted_price == ''){
//         $(this).find(".custom_original_price").show();
//     }else{
//         $(this).find(".custom_original_price").hide();
//     }
// });

//         jQuery.getJSON('/cart.js', function(cart) {
//     let items = cart.items;
//     for(var i=0; i < items.length; i++){
// if(typeof items[i].selling_plan_allocation !== 'undefined'){
// $(".cart_drawer_main form.cart.ajaxcart").append('<input class="discounted_value" type="hidden" name="discount" value="FREESUBSHIP" >');
// }
// }
// });
        
//  },2000); 
// });
$('body').on('click', '.ajaxcart__qty--plus', function () {

    let $clickedEl = $(this);

    // Update qty
    var id = $(this).attr('data-id');
    var qty = parseInt($('.get-qty-' + id).val());
    qty += 1;

    updateCart(id, qty);  // async but okay for now

    $(".discounted_value").remove();
    $(".custom_original_price").hide();

    setTimeout(function () {
        priceContainer($clickedEl);
    }, 300);

    var free_ship_text = $(".progress_main_bar .progress-bar").attr("free-shipping");


    /* ---------------------------------------------------
     *  FIRST: UPDATE SHIPPING BAR & TEXT
     * --------------------------------------------------- */
    setTimeout(function () {
        //   alert(3)
        jQuery.getJSON('/cart.js', function (cart) {

            $(".CartCount__icon-text").html(cart.item_count);

            var cart_val_div = cart.total_price / 100;
            const newPercentValue = (cart_val_div / free_ship_text) * 100;
            let items = cart.items;

            let hasSellingPlan = items.some(item => item.selling_plan_allocation);

            // 💥 If selling plan item → just console logs (your logic)
            if (hasSellingPlan) {
                console.log("cart_val_div = " + cart_val_div);
                console.log("newPercentValue = " + newPercentValue);
            }

            // 🟦 Free shipping normal logic (same for all)
            $('.progress-bar').css('width', newPercentValue + '%');

            const remain = (free_ship_text - cart_val_div);
            const final_val = remain.toFixed(2);

            $(".simple_freeshipping_text p b").html("$" + final_val);

            if (remain > 0) {
                $(".simple_freeshipping_text p").show();
                $(".free_shipping_message").hide();
            } else {
                $(".free_shipping_message").show();
                $(".simple_freeshipping_text p").hide();
            }

            // When cart empty
            if (cart.item_count < 1) {
                $('.progress-bar').css('width', newPercentValue + '%');
                $(".simple_freeshipping_text p b").html("$" + final_val);

                if (remain > 0) {
                    $(".simple_freeshipping_text p").show();
                    $(".free_shipping_message").hide();
                } else {
                    $(".free_shipping_message").show();
                    $(".simple_freeshipping_text p").hide();
                }
            }

        });
    }, 500);



    /* ---------------------------------------------------
     *  SECOND: ORIGINAL PRICE / DISCOUNT Check
     * --------------------------------------------------- */
    setTimeout(function () {

        // Show original price if no discounted price
        $(".ajaxcart__product").each(function () {
            var discounted_price = $(this).find(".discounted_price_main").text();

            if (discounted_price == "") {
                $(this).find(".custom_original_price").show();
            } else {
                $(this).find(".custom_original_price").hide();
            }
        });

        // Add discount input if selling plan exists
        jQuery.getJSON('/cart.js', function (cart) {
            let items = cart.items;

            let hasSellingPlan = items.some(item => item.selling_plan_allocation);

            if (hasSellingPlan) {
                $(".cart_drawer_main form.cart.ajaxcart")
                    .append('<input class="discounted_value" type="hidden" name="discount" value="FREESUBSHIP">');
            }
        });

    }, 1200);

});

// $('body').on('click', '.ajaxcart__qty--minus', function(){
// let $clickedEl = $(this);
//  setTimeout(function() {
//         priceContainer($clickedEl);
//     }, 1000);
//   var id = $(this).attr('data-id');
//   var qty = parseInt($('.get-qty-'+id).val());
//   qty -= 1;
//   updateCart(id,qty)
//       $(".discounted_value").remove();
//   $(".custom_original_price").hide();
//     var free_ship_text = $(".progress_main_bar .progress-bar").attr("free-shipping");
//     setTimeout(function(){
//         jQuery.getJSON('/cart.js', function(cart) {
//   $(".CartCount__icon-text").html(cart.item_count);
//           var cart_val_div = cart.total_price / 100;
// const newPercentValue = (cart_val_div / free_ship_text) * 100;
//        let items = cart.items;
//     for(var i=0; i < items.length; i++){
// if(typeof items[i].selling_plan_allocation !== 'undefined'){
//    $('.progress-bar').css('width','100%');   
//    $(".free_shipping_message").show();
//             $(".simple_freeshipping_text p").hide();
// }else{
//    $('.progress-bar').css('width',newPercentValue+'%');   
//    const newPercentValue2 = (free_ship_text - cart_val_div);
//           const final_val = newPercentValue2.toFixed(2)
//    $(".simple_freeshipping_text p b").html("$"+final_val);
//                       if(newPercentValue2 > 0){
//             $(".simple_freeshipping_text p").show();
//             $(".free_shipping_message").hide();
//           }else{
//             $(".free_shipping_message").show();
//             $(".simple_freeshipping_text p").hide();
//           }
// }
// }
//                if(cart.item_count < 1)   {
//         $('.progress-bar').css('width',newPercentValue+'%');   
//    const newPercentValue2 = (free_ship_text - cart_val_div);
//           const final_val = newPercentValue2.toFixed(2)
//    $(".simple_freeshipping_text p b").html("$"+final_val);
//                       if(newPercentValue2 > 0){
//             $(".simple_freeshipping_text p").show();
//             $(".free_shipping_message").hide();
//           }else{
//             $(".free_shipping_message").show();
//             $(".simple_freeshipping_text p").hide();
//           }
//       }

//         });      
//     },500);
  

//       setTimeout(function(){
//             $(".ajaxcart__product").each(function() {
//     var discounted_price = $(this).find(".discounted_price_main").text();
//     if(discounted_price == ''){
//         $(this).find(".custom_original_price").show();
//     }else{
//         $(this).find(".custom_original_price").hide();
//     }
// });

//         jQuery.getJSON('/cart.js', function(cart) {
//     let items = cart.items;
//     for(var i=0; i < items.length; i++){
// if(typeof items[i].selling_plan_allocation !== 'undefined'){
// $(".cart_drawer_main form.cart.ajaxcart").append('<input class="discounted_value" type="hidden" name="discount" value="FREESUBSHIP" >');
// }
// }
// });
        
//  },2000);
// });
$('body').on('click', '.ajaxcart__qty--minus', function () {

    let $clickedEl = $(this);

    // Update quantity
    var id = $(this).attr('data-id');
    var qty = parseInt($('.get-qty-' + id).val());
    qty -= 1;

    updateCart(id, qty); // Update cart async

    $(".discounted_value").remove();
    $(".custom_original_price").hide();

    // Run price container after small delay
    setTimeout(function () {
        priceContainer($clickedEl);
    }, 300);

    var free_ship_text = $(".progress_main_bar .progress-bar").attr("free-shipping");

    /* ---------------------------------------------------
     *  1️⃣ Update shipping progress bar and message
     * --------------------------------------------------- */
    setTimeout(function () {
        //   alert(4)
        jQuery.getJSON('/cart.js', function (cart) {

            $(".CartCount__icon-text").html(cart.item_count);

            var cart_val_div = cart.total_price / 100;
            const newPercentValue = (cart_val_div / free_ship_text) * 100;
            let items = cart.items;

            // Check if any item has selling plan
            let hasSellingPlan = items.some(item => item.selling_plan_allocation);

            // FREE SHIPPING if cart value >= threshold
            if (cart_val_div >= free_ship_text) {
                $('.progress-bar').css('width', '100%');
                $(".free_shipping_message").show();
                $(".simple_freeshipping_text p").hide();
            } else {
                // Normal progress bar calculation
                $('.progress-bar').css('width', newPercentValue + '%');

                const remain = (free_ship_text - cart_val_div).toFixed(2);
                $(".simple_freeshipping_text p b").html("$" + remain);

                if (remain > 0) {
                    $(".simple_freeshipping_text p").show();
                    $(".free_shipping_message").hide();
                } else {
                    $(".free_shipping_message").show();
                    $(".simple_freeshipping_text p").hide();
                }
            }

            // When cart is empty
            if (cart.item_count < 1) {
                $('.progress-bar').css('width', '0%');
                $(".simple_freeshipping_text p b").html("$" + free_ship_text);
                $(".simple_freeshipping_text p").show();
                $(".free_shipping_message").hide();
            }

        });
    }, 500);

    /* ---------------------------------------------------
     *  2️⃣ Show/hide original price & add discount input for selling plan
     * --------------------------------------------------- */
    setTimeout(function () {

        // Show original price if no discounted price
        $(".ajaxcart__product").each(function () {
            var discounted_price = $(this).find(".discounted_price_main").text();
            if (discounted_price == '') {
                $(this).find(".custom_original_price").show();
            } else {
                $(this).find(".custom_original_price").hide();
            }
        });

        // Add discount input if selling plan exists
        jQuery.getJSON('/cart.js', function (cart) {
            let items = cart.items;
            let hasSellingPlan = items.some(item => item.selling_plan_allocation);

            if (hasSellingPlan) {
                if ($(".cart_drawer_main form.cart.ajaxcart .discounted_value").length === 0) {
                    $(".cart_drawer_main form.cart.ajaxcart")
                        .append('<input class="discounted_value" type="hidden" name="discount" value="FREESUBSHIP">');
                }
            }
        });

    }, 1200);

});

// $(document).on("change","input.ajaxcart__qty-num", function(){
// let $clickedEl = $(this);
//  setTimeout(function() {
//         priceContainer($clickedEl);
//     }, 1000);
//    $(".discounted_value").remove();
//   $(".custom_original_price").hide();
//     var free_ship_text = $(".progress_main_bar .progress-bar").attr("free-shipping");
//     setTimeout(function(){
//         jQuery.getJSON('/cart.js', function(cart) {
//   $(".CartCount__icon-text").html(cart.item_count);
//           var cart_val_div = cart.total_price / 100;
// const newPercentValue = (cart_val_div / free_ship_text) * 100;
//        let items = cart.items;
//     for(var i=0; i < items.length; i++){
// if(typeof items[i].selling_plan_allocation !== 'undefined'){
//    $('.progress-bar').css('width','100%');   
//    $(".free_shipping_message").show();
//             $(".simple_freeshipping_text p").hide();
// }else{
//    $('.progress-bar').css('width',newPercentValue+'%');   
//    const newPercentValue2 = (free_ship_text - cart_val_div);
//           const final_val = newPercentValue2.toFixed(2)
//    $(".simple_freeshipping_text p b").html("$"+final_val);
//                       if(newPercentValue2 > 0){
//             $(".simple_freeshipping_text p").show();
//             $(".free_shipping_message").hide();
//           }else{
//             $(".free_shipping_message").show();
//             $(".simple_freeshipping_text p").hide();
//           }
// }
// }
//                if(cart.item_count < 1)   {
//         $('.progress-bar').css('width',newPercentValue+'%');   
//    const newPercentValue2 = (free_ship_text - cart_val_div);
//           const final_val = newPercentValue2.toFixed(2)
//    $(".simple_freeshipping_text p b").html("$"+final_val);
//                       if(newPercentValue2 > 0){
//             $(".simple_freeshipping_text p").show();
//             $(".free_shipping_message").hide();
//           }else{
//             $(".free_shipping_message").show();
//             $(".simple_freeshipping_text p").hide();
//           }
//       }

//         });      
//     },500);
  

//       setTimeout(function(){
//             $(".ajaxcart__product").each(function() {
//     var discounted_price = $(this).find(".discounted_price_main").text();
//     if(discounted_price == ''){
//         $(this).find(".custom_original_price").show();
//     }else{
//         $(this).find(".custom_original_price").hide();
//     }
// });

//         jQuery.getJSON('/cart.js', function(cart) {
//     let items = cart.items;
//     for(var i=0; i < items.length; i++){
// if(typeof items[i].selling_plan_allocation !== 'undefined'){
// $(".cart_drawer_main form.cart.ajaxcart").append('<input class="discounted_value" type="hidden" name="discount" value="FREESUBSHIP" >');
// }
// }
// });
        
//  },2000);
// });
$(document).on("change", "input.ajaxcart__qty-num", function () {

    let $clickedEl = $(this);

    // Run price container after small delay
    setTimeout(function () {
        priceContainer($clickedEl);
    }, 300);

    $(".discounted_value").remove();
    $(".custom_original_price").hide();

    var free_ship_text = $(".progress_main_bar .progress-bar").attr("free-shipping");

    /* ---------------------------------------------------
     *  1️⃣ Update shipping progress bar & message
     * --------------------------------------------------- */
    setTimeout(function () {
        //   alert(5)
        jQuery.getJSON('/cart.js', function (cart) {

            $(".CartCount__icon-text").html(cart.item_count);

            var cart_val_div = cart.total_price / 100;
            const newPercentValue = (cart_val_div / free_ship_text) * 100;

            let items = cart.items;

            // Check if any item has selling plan
            let hasSellingPlan = items.some(item => item.selling_plan_allocation);

            // FREE SHIPPING if cart value >= threshold
            if (cart_val_div >= free_ship_text) {
                $('.progress-bar').css('width', '100%');
                $(".free_shipping_message").show();
                $(".simple_freeshipping_text p").hide();
            } else {
                // Normal progress bar calculation
                $('.progress-bar').css('width', newPercentValue + '%');

                const remain = (free_ship_text - cart_val_div).toFixed(2);
                $(".simple_freeshipping_text p b").html("$" + remain);

                if (remain > 0) {
                    $(".simple_freeshipping_text p").show();
                    $(".free_shipping_message").hide();
                } else {
                    $(".free_shipping_message").show();
                    $(".simple_freeshipping_text p").hide();
                }
            }

            // When cart is empty
            if (cart.item_count < 1) {
                $('.progress-bar').css('width', '0%');
                $(".simple_freeshipping_text p b").html("$" + free_ship_text);
                $(".simple_freeshipping_text p").show();
                $(".free_shipping_message").hide();
            }

        });
    }, 500);

    /* ---------------------------------------------------
     *  2️⃣ Show/hide original price & add discount input for selling plan
     * --------------------------------------------------- */
    setTimeout(function () {

        // Show original price if no discounted price
        $(".ajaxcart__product").each(function () {
            var discounted_price = $(this).find(".discounted_price_main").text();

            if (discounted_price == '') {
                $(this).find(".custom_original_price").show();
            } else {
                $(this).find(".custom_original_price").hide();
            }
        });

        // Add discount input if selling plan exists
        jQuery.getJSON('/cart.js', function (cart) {
            let items = cart.items;
            let hasSellingPlan = items.some(item => item.selling_plan_allocation);

            if (hasSellingPlan) {
                // Only append once
                if ($(".cart_drawer_main form.cart.ajaxcart .discounted_value").length === 0) {
                    $(".cart_drawer_main form.cart.ajaxcart")
                        .append('<input class="discounted_value" type="hidden" name="discount" value="FREESUBSHIP">');
                }
            }
        });

    }, 1200);

});

$('body').on('click','span#AddToCartText',function () {
 setTimeout(function(){
   cart_drawer_slider();
   }, 800)
})

function removeCartItem1(id){
    jQuery.getJSON('/cart.js', function(cart) {
var getCartcount = cart.item_count;
    
    if(getCartcount == 0){
     
 $('.cart_pro_wrapp').html('');
    $('span.cart-item-count-bubble.cart-item-count-header.cart-item-count-header--quantity').remove();
   var getCathtml =  $('.custom_cart_btns').html();
$('div#CartContainer').html(getCathtml);
$('.empty_cart_btns.not_empty_cart').show();
    }
})
}
function removeCartItem(id){

  $.ajax({
     type: 'POST',
     url: '/cart/change.js',
     data: {
         id: id,
         quantity: 0 
     },
     dataType: 'json',
     success: function(cartData) {
     
         getCart()
     },
     error: function(xhr, status, error) {
      
         console.log(error);
     }
  });
  
}
